import { useContext } from "react";
import styled from "styled-components";
import Button from "../button";
import { BatchActionsContext } from "./table-batch-actions-context";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled(Button).withConfig({
  displayName: "table-action-button__StyledButton",
  componentId: "sc-184guwy-0"
})(["&.ant-btn-link{color:#fff;&:hover{color:#fff;background-color:", ";}&:active,&.active{color:#fff;background-color:", ";}}"], p => p.theme.colors.primary.hover, p => p.theme.colors.primary.active);
function TableActionButton(props) {
  const count = useContext(BatchActionsContext);
  return /*#__PURE__*/_jsx(StyledButton, {
    ...props,
    type: "link",
    tabIndex: count > 0 ? 0 : -1
  });
}
export default TableActionButton;